import { Banner, Icon, Spinner, Text } from '@dixa/lib-shared-habla';
import type { DynamicToolUIPart, ToolUIPart } from 'ai';

import styles from './mimSidekickToolPartIndicator.module.scss';

type MimSidekickToolPartIndicatorProps = {
  part: ToolUIPart | DynamicToolUIPart;
};

export const MimSidekickToolPartIndicator = ({
  part,
}: MimSidekickToolPartIndicatorProps): JSX.Element | null => {
  const toolName = part.type === 'dynamic-tool' ? part.toolName : '';

  switch (part.state) {
    case 'input-streaming':
      return (
        <div className={styles.toolIndicator}>
          <Spinner size={12} />
          <Text.Paragraph variant="4">Preparing tool call…</Text.Paragraph>
        </div>
      );
    case 'input-available':
      return (
        <div className={styles.toolIndicator}>
          <Spinner size={12} />
          <Text.Paragraph variant="4">Calling {toolName}…</Text.Paragraph>
        </div>
      );
    case 'output-available':
      return (
        <div className={styles.toolIndicator}>
          <Icon name="done" />
          <Text.Paragraph variant="4">Done: {toolName}</Text.Paragraph>
        </div>
      );
    case 'output-error':
      return (
        <Banner
          variant="fail"
          description={
            <Text.Paragraph>
              Failed: {toolName} - {part.errorText ?? 'unknown error'}
            </Text.Paragraph>
          }
        />
      );
    default:
      return null;
  }
};
